module.exports = __webpack_public_path__ + "img/1728524913969-image.jpg.aa866165.webp";